module.exports = __webpack_public_path__ + "static/media/partena_logo.8c8629a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/integrations_logos/partena_logo.png
// module id = 302
// module chunks = 0